import React, { Component } from 'react';

import arrowUp from 'images/arrow-up.svg';
import arrowDown from 'images/arrow-down.svg';

class ButtonBorderChanger extends Component {
  state = {
    defaultValue: this.props.defaultValue || 1,
  };

  handleChange = value => {
    const { handleChange, max, min } = this.props;
    switch (value) {
      case 'up':
        if (this.state.defaultValue === max) {
          break;
        }
        this.setState({ defaultValue: this.state.defaultValue + 1 });
        handleChange(this.state.defaultValue + 1);
        break;
      case 'down':
        if (this.state.defaultValue === min) {
          break;
        }
        this.setState({ defaultValue: this.state.defaultValue - 1 });
        handleChange(this.state.defaultValue - 1);
        break;
      default:
        return;
    }
  };

  render() {
    const { defaultValue } = this.state;
    const { header } = this.props;
    return (
      <div className="style-form__col">
        <div className="style-form__subtitle top">{header}</div>
        <div className="select-count">
          <div className="select-count__inner">
            <div className="select-count__input">{defaultValue}</div>
            <div className="select-count__btn">
              <div
                className="select-count__addon decrement"
                onClick={() => this.handleChange('up')}>
                <img src={arrowUp} alt="up" />
              </div>
              <div
                className="select-count__addon increment"
                onClick={() => this.handleChange('down')}>
                <img src={arrowDown} alt="down" />
              </div>
            </div>
          </div>
          <div className="select-count__text">pixels</div>
        </div>
      </div>
    );
  }
}

export default ButtonBorderChanger;



// WEBPACK FOOTER //
// ./src/components/ButtonBorderChanger/ButtonBorderChanger.js